import { useMutation, useQueryClient } from "react-query";
import queryKeys from "../../constants/queryKeys";
import caseNestService from "../../services/caseNestService";

const useDeleteSnippet = () => {
  const queryClient = useQueryClient();
  return useMutation(caseNestService.deleteSnippet, {
    onMutate: async (deleteSnippet) => {
      const queryKey = [queryKeys.snippets, deleteSnippet?.caseTypeId];
      await queryClient.cancelQueries(queryKey);
      const snapshotOfPreviousSnippets = queryClient.getQueryData(queryKey);

      if (snapshotOfPreviousSnippets) {
        queryClient.setQueryData(queryKey, (oldSnippets) =>
          oldSnippets?.data?.filter((oldSnippet) => oldSnippet.id === deleteSnippet.id)
        );
      }
      return {
        snapshotOfPreviousSnippets,
      };
    },

    onError: (error, deleteSnippet, { snapshotOfPreviousSnippets }) => {
      queryClient.setQueryData([queryKeys.snippets, deleteSnippet?.caseTypeId], snapshotOfPreviousSnippets);
    },

    onSuccess() {
      queryClient.invalidateQueries(queryKeys.snippets);
    },
  });
};

export default useDeleteSnippet;
